// ParameterCard.js
import React, { useEffect, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import './ParameterCard.css';

const ParameterCard = ({ parameter, selectedValues, setSelectedValues, values }) => {
    const [filter, setFilter] = useState('');

    useEffect(() => {
        // Update the selection based on initial values
        if (selectedValues[parameter.name]?.includes('-1')) {
            handleSelectAllChange(true);
        }
    }, []);

    const handleValueChange = (value) => {
        setSelectedValues(parameter, value);
    };

    const handleSelectAllChange = (isChecked) => {
        if (isChecked) {
            setSelectedValues(parameter, '-1');
        } else {
            setSelectedValues(parameter, []);
        }
    };

    const handleIndividualValueChange = (value) => {
        const newSelectedValues = [...(selectedValues[parameter.name] || [])];
        if (newSelectedValues.includes('-1')) {
            newSelectedValues.splice(newSelectedValues.indexOf('-1'), 1);
        }
        else if (newSelectedValues.includes(value)) {
            newSelectedValues.splice(newSelectedValues.indexOf(value), 1);
        } else {
            newSelectedValues.push(value);
            if (newSelectedValues.length === values.length) {
                newSelectedValues.push('-1');
            }
        }
        setSelectedValues(parameter, newSelectedValues);
    };

    const filteredValues = values.filter(option => 
        option.value.toLowerCase().includes(filter.toLowerCase())
    );

    return (
        <Card className="mb-3 parameter-card">
            <Card.Body className=''>
                <Card.Title className='text-left text-info'>{parameter.displayName.toUpperCase()}</Card.Title>
                <Form.Control 
                    type="text" 
                    placeholder="Start typing to filter values" 
                    value={filter} 
                    onChange={(e) => setFilter(e.target.value)} 
                    size='sm'
                    className='mt-2'
                />
                <div className="values-list p-2 mt-3">
                    {filteredValues.length > 0 &&
                        <Form.Check
                            key={'-1'}
                            type="checkbox"
                            label={"All"}
                            checked={selectedValues[parameter.name]?.includes('-1') || false}
                            onChange={() => handleValueChange('-1')}
                        />
                    }
                    {filteredValues.map(option => (
                        <Form.Check 
                            key={option.id} 
                            type="checkbox" 
                            label={option.value}
                            checked={(selectedValues[parameter.name]?.includes('-1') || selectedValues[parameter.name]?.includes(option.id)) || false}
                            onChange={() => handleValueChange(option.id)}
                        />
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default ParameterCard;